import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography } from "@material-ui/core";

import { XAxis } from "./XAxis";
import { RevenueChanges } from "./RevenueChanges";
import { UNREALIZED_COLORS } from "../../constants";
import { currencyFormatter, onlyZeroValuesInArray } from "../../../../services";
import { Button } from "../../../../components/base";
import { NoDataCard } from "../../../../components/parts";
import { UnrealizedBarChart } from "../../../../components/charts/UnrealizedBarChart";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3.5)}px ${theme.spacing(3)}px`,
  },
}));

export const TradingRevenueCharges = ({
  currentChartData,
  estimationChartData,
  currentAddingPowerRevenues,
  currentReducingUnrealizedRevenues,
  estimationAddingPowerRevenues,
  estimationReducingUnrealizedRevenues,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid className={classes.box} item xs={12} sm={8}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Trading Revenues Changes</Typography>
        <Button text="UNCONNECTED TENANTS LIST" />
      </Grid>

      <Grid container spacing={6} justifyContent="space-around" alignItems="center">
        {onlyZeroValuesInArray(
          currentChartData.map((obj) => Object.values(obj)),
          0
        ) ? (
          <Grid item xs={12} sm={6}>
            <RevenueChanges
              year="1Y"
              values={[
                currencyFormatter(currentReducingUnrealizedRevenues, currencySymbol),
                currencyFormatter(currentAddingPowerRevenues, currencySymbol),
              ]}
              trading
            />
            <UnrealizedBarChart
              chartData={currentChartData}
              colors={UNREALIZED_COLORS}
              barSize={20}
              bottom={-10}
            />
            <XAxis
              labels={[
                "Today’s Unrealized trading revenues",
                "Revised Unrealized trading revenues",
                "New power revenues",
              ]}
            />
          </Grid>
        ) : (
          <Grid container style={{ width: "auto" }}>
            <NoDataCard withShaDowBox={false} boxStyle={{ marginTop: 24 }} />
          </Grid>
        )}
        {onlyZeroValuesInArray(
          estimationChartData.map((obj) => Object.values(obj)),
          0
        ) ? (
          <Grid item xs={12} sm={6}>
            <RevenueChanges
              year="20Y"
              values={[
                currencyFormatter(estimationReducingUnrealizedRevenues, currencySymbol),
                currencyFormatter(estimationAddingPowerRevenues, currencySymbol),
              ]}
              trading
            />
            <UnrealizedBarChart
              chartData={estimationChartData}
              colors={UNREALIZED_COLORS}
              barSize={20}
              bottom={-10}
            />
            <XAxis
              labels={[
                "Current est. 20Y Unrealized revenues",
                "Revised 20Y Unrealized revenues",
                "Revised 20Y power revenues",
              ]}
            />
          </Grid>
        ) : (
          <Grid container style={{ width: "auto" }}>
            <NoDataCard withShaDowBox={false} boxStyle={{ marginTop: 24 }} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
